module.exports = __webpack_public_path__ + "img/shizhongIcon.d6b75dda.png";